
export default {
  methods: {
    enter(el) {
      el.style.animation = 'none';
      el.style.maxHeight = `${el.offsetHeight}px`;
      el.style.animation = '';
    },
    afterEnter(el) {
      el.style.maxHeight = '';
    },
    leave(el) {
      el.style.maxHeight = `${el.offsetHeight}px`;
    },
    afterLeave(el) {
      el.style.maxHeight = '';
    }
  }
};
